// extracted by mini-css-extract-plugin
module.exports = {"page":"Signup_page__6w18t","password":"Signup_password__3_49b","eye":"Signup_eye__1H8KD"};